<div class="ui-g-12" [hidden]="activatedRoute.children.length > 0">
  <div class="row p-1">
    <div class="col-12 pageTitle">
      <h2>&nbsp;&nbsp;&nbsp;{{ title }} - Reports</h2>
    </div>
  </div>

  <div class="card">
    <div class="p-fluid formgrid grid">
      <div class="field col-12 md:col-4">
        <span class="ui-float-label">
          <p-dropdown
            *ngIf="reportTypeList"
            dataKey="value"
            [options]="reportTypeList"
            optionLabel="key"
            placeholder="Select Report Type"
            class="ui-fluid"
            [(ngModel)]="reportCategory"
            (onChange)="searchonId(reportCategory)"
          ></p-dropdown>
        </span>
      </div>
    </div>
  </div>

  <p-table
    *ngIf="report"
    [columns]="cols"
    [value]="report.data"
    selectionMode="single"
    dataKey="reportID"
    [resetPageOnSort]="false"
    [lazy]="false"
    [(selection)]="selectedreport"
    [paginator]="showRecords"
    [rows]="10"
  >
    <ng-template pTemplate="header" let-columns>
      <tr *ngIf="showRecords == true">
        <th
          *ngFor="let col of columns"
          [pSortableColumn]="col.field"
          class="col-2"
        >
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
        <th class="col-1">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          <ng-container *ngIf="col.field != 'patientFlag'; else ptflag">
            {{ rowData[col.field] }}
          </ng-container>
          <ng-template #ptflag>
            <ng-container
              *ngIf="
                rowData['patientFlag'] && col.field == 'patientFlag';
                else ptflagNo
              "
              >Yes</ng-container
            >
          </ng-template>
          <ng-template #ptflagNo>No</ng-template>
        </td>
        <td>
          <button
            pButton
            type="button"
            icon="pi pi-search"
            pTooltip="View Report"
            class="p-button-link ml-5"
            (click)="onViewReport_Click(rowData)"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <div class="w-12 bg-white">
        <div class="" style="text-align: center">
          <img
            _ngcontent-ng-c683320295=""
            class="profile-image"
            style="border-radius: 50%; width: 10rem; padding-top: 1rem"
            src="assets/imagesNew/table_error.png"
          />
        </div>
        <hr style="margin-bottom: 0.5rem" />
        <div
          class=""
          style="text-align: center; font-size: larger; color: #1d428f"
        >
          <i>No records found</i>
        </div>
      </div>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="popupDisplayReportsParams"
    [draggable]="true"
    [modal]="true"
    positionType="absolute"
    [style]="{ width: '25vw' }"
    [baseZIndex]="10000"
    [maximizable]="true"
  >
    <p-header> Report Parameter Details </p-header>

    <div class="grid">
      <div class="col-12">
        <app-reports-view-params
          #reportsViewParams
          (btnOpenReport_Clicked)="onReportViewParam_Click($event)"
        ></app-reports-view-params>
      </div>
    </div>
    <p-footer style="display: flex; justify-content: center"> </p-footer>
  </p-dialog>
</div>

<div [hidden]="activatedRoute.children.length === 0">
  <div class="mt-2">
    <p-button label="Back" (click)="back()"></p-button>
    <hr />
  </div>
  <router-outlet></router-outlet>
</div>
